<template>
<div>
  <div class="card">
    <div class="card-header">
      <p-button type="default" link style="float: left;" @click="navigateBack()" class="mt-0" title="Zurück"><i class="bi bi-arrow-left" style="font-size: 16px;"></i></p-button><h3 class="title mb-1"><b>{{ trainerName }}</b></h3>
    </div>
    <div class="card-body">
      <form>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Vor- und Nachname"
                      v-model="trainerName">
            </fg-input>
          </div>
          <div class="col-md-6">
          </div>
        </div>
          <h5 class="pt-4">Kontaktdaten</h5>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Telefon"
                      v-model="trainerTelefon">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="email"
                      label="E-Mail"
                      v-model="trainerMail">
            </fg-input>
          </div>
        </div>
        <h5 class="pt-4">Notfallkontakt</h5>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Name Notfallkontakt"
                      v-model="trainerNotfallkontaktName">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Telefon Notfallkontakt"
                      v-model="trainerNotfallkontaktNummer">
            </fg-input>
          </div>
        </div>
        <h5 class="pt-4">Vertragsdaten</h5>
        <div class="row">
          <div class="col-md-3">
            <label>Wochenstunden</label><br>
            <el-input-number v-model="trainerWochenstunden" :min="0" :max="60"></el-input-number>
          </div>
          <div class="col-md-3">
            <label>Urlaubstage</label><br>
            <el-input-number v-model="trainerUrlaubstage" :min="0" :max="50"></el-input-number>
          </div>
          <div class="col-md-6">
            <label>Letzter Erste-Hilfe-Kurs</label><br>
            <el-date-picker
              v-model="trainerErsteHilefeKursDatum"
              type="month"
              placeholder="Monat wählen"
              format="MM/yyyy"
              :picker-options="pickerOptions1">
            </el-date-picker>
          </div>
        </div>
        <div class="row pb-4">
          <div class="col-md-12">
        <h5 class="pt-4">Arbeitsbereiche</h5>
        <div class="row">
          <div class="col">
            <p-switch v-model="trainerIsEinweiser" type="primary">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
            </p-switch> Betreuer
          </div>
          <div class="col">
              <p-switch v-model="trainerIsRetter" type="primary">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
            </p-switch> Retter
          </div>

          <div class="col">
              <p-switch v-model="trainerIsHT" type="primary">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
            </p-switch> Tagesverantwortlicher
          </div>

          <div class="col">
              <p-switch v-model="trainerIsRetterpruefung" type="primary">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
            </p-switch> Retterprüfungen
          </div>
        </div>
          </div>
        </div>

        <div class="text-right pt-3">
          <button type="reset" class="btn btn-danger btn-fill btn-wd" @click.prevent="removeTrainer">
            <i class="bi bi-trash"></i> Löschen
          </button>
          <button type="reset" class="btn btn-warning btn-fill btn-wd" @click.prevent="onCancel">
            Abbrechen
          </button>
          <button type="submit" class="btn btn-success btn-fill btn-wd" @click.prevent="updateTrainer">
            Speichern
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
<!--
  <div class="card mt-3">
    <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <h5 class="title mb-0">Verträge</h5>
        </div>
        <div class="col-md-4">
          <p-button type="default" style="float: right;" @click="showNewContractDialog()" title="Neuen Vertrag anlegen"><i class="bi bi-plus" style="font-size: 16px;"></i></p-button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <el-table :data="contracts" header-row-class-name="text-primary" empty-text="Keine Verträge hinterlegt.">
            <el-table-column prop="title" label="Titel" min-width="160"></el-table-column>
            <el-table-column prop="assignedAtLabel" label="Vorgelegt am" min-width="140"></el-table-column>
            <el-table-column prop="status" label="Status" min-width="140"></el-table-column>
            <el-table-column prop="completedAtLabel" label="Erledigt am" min-width="140"></el-table-column>
            <el-table-column label="" min-width="120">
              <template #default="scope">
                <div v-if="scope.row.documentSignedUrl && scope.row.documentSignedUrl !== ''" class="float-left">
                  <a :href="scope.row.documentSignedUrl" target="_blank" class="btn btn-sm btn-primary" title="Dokument herunterladen"><i class="bi bi-download"></i></a>
                </div>
                <p-button size="sm" type="default" @click="showContractLink(scope.row)" title="Link anzeigen" class="ml-2 float-left" v-if="!scope.row.documentSignedUrl || scope.row.documentSignedUrl === ''"><i class="bi bi-link"></i></p-button>
                <p-button size="sm" type="default" @click="sendReminderVertrag(scope.row.id)" title="Erinnerung senden" class="ml-2 float-left" v-if="!scope.row.documentSignedUrl || scope.row.documentSignedUrl === ''"><i class="bi bi-bell"></i></p-button>
                <p-button size="sm" type="danger" @click="removeContract(scope.row)" title="Vertrag löschen" class="ml-2 float-left"><i class="bi bi-trash"></i></p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>-->

  <div class="card mt-3">
    <div class="card-header">
      <h5 class="title mb-0">Unterweisungen</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <h6>Offen</h6>
          <el-table :data="openInstructions" header-row-class-name="text-primary" empty-text="Keine offenen Unterweisungen.">
            <el-table-column prop="title" label="Titel" min-width="160"></el-table-column>
            <el-table-column prop="assignedAtLabel" label="Zuweisung" min-width="140"></el-table-column>
            <el-table-column prop="completedAtLabel" label="Erledigt am" min-width="140"></el-table-column>
            <el-table-column label="" min-width="150">
              <template #default="scope">
                <p-button size="sm" type="default" @click="showInstructionLink(scope.row)" title="Link anzeigen" class="ml-2 float-left"><i class="bi bi-link"></i></p-button>
                <p-button size="sm" type="default" @click="sendReminderUnterweisung(scope.row.id)" title="Erinnerung senden" class="ml-2 float-left"><i class="bi bi-bell"></i></p-button>
                <p-button size="sm" type="danger" @click="removeInstruction(scope.row)" title="Unterweisung löschen" class="ml-2 float-left"><i class="bi bi-trash"></i></p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-md-6">
          <h6>Erledigt</h6>
          <el-table :data="doneInstructions" header-row-class-name="text-primary" empty-text="Keine erledigten Unterweisungen.">
            <el-table-column prop="title" label="Titel" min-width="160"></el-table-column>
            <el-table-column prop="assignedAtLabel" label="Zuweisung" min-width="140"></el-table-column>
            <el-table-column prop="completedAtLabel" label="Erledigt am" min-width="140"></el-table-column>
            <el-table-column label="Unterschrift" min-width="120">
              <template #default="scope">
                <div v-if="scope.row.signature">
                  <img :src="scope.row.signature" alt="Unterschrift" @click="showSignatureDialogFunction(scope.row)" style="max-height: 60px; max-width: 100px; border: 1px solid #ccc;"/>
                </div>
                <div v-else>
                  -
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-3" v-loading="accountLoading">
    <div class="card-header">
      <h5 class="title mb-0">Verknüpfter Benutzer-Account</h5>
    </div>
    <div class="card-body">
      <div v-if="linkedAuthUid">
        <p><i class="bi bi-check-circle-fill text-success"></i> Verknüpft mit Benutzer <b>{{ linkedAuthUsername }}</b></p>
        <p-button type="danger" size="sm" @click="unlinkAccount"><i class="bi bi-x-circle"></i> Verknüpfung aufheben</p-button>
      </div>
      <div v-else>
        <p class="text-muted">Kein Benutzer-Account verknüpft.</p>
        <p-button type="success" size="sm" @click="createLinkedAccount" :disabled="!trainerMail" class="mr-2">
          <i class="bi bi-person-plus"></i> Neuen Account anlegen
        </p-button>
        <p-button type="default" size="sm" @click="openLinkDialog">
          <i class="bi bi-link"></i> Bestehenden Account verknüpfen
        </p-button>
        <p v-if="!trainerMail" class="text-warning mt-2"><small>Zum Anlegen eines Accounts muss eine E-Mail-Adresse hinterlegt sein.</small></p>
      </div>
    </div>
  </div>

  <!-- <div class="card mt-3" v-loading="documentsLoading">
    <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <h5 class="title mb-0">Personalakte</h5>
        </div>
        <div class="col-md-4">
          <p-button type="default" style="float: right;" @click="showUploadDocumentDialog()" title="Dokument hochladen"><i class="bi bi-upload" style="font-size: 16px;"></i></p-button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <el-table :data="personalDocuments" header-row-class-name="text-primary" empty-text="Keine Dokumente vorhanden.">
        <el-table-column prop="title" label="Titel" min-width="160"></el-table-column>
        <el-table-column prop="uploadedByName" label="Hochgeladen von" min-width="140"></el-table-column>
        <el-table-column prop="uploadedAtLabel" label="Datum" min-width="120"></el-table-column>
        <el-table-column label="Für Mitarbeiter sichtbar" min-width="130">
          <template #default="scope">
            <p-switch v-model="scope.row.visibleToEmployee" type="primary" @input="toggleDocumentVisibility(scope.row)">
              <i class="fa fa-check" slot="on"></i>
              <i class="fa fa-times" slot="off"></i>
            </p-switch>
          </template>
        </el-table-column>
        <el-table-column label="" min-width="120">
          <template #default="scope">
            <p-button size="sm" type="primary" @click="downloadDocument(scope.row)" title="Herunterladen" class="float-left"><i class="bi bi-download"></i></p-button>
            <p-button size="sm" type="danger" @click="removeDocument(scope.row)" title="Löschen" class="ml-2 float-left"><i class="bi bi-trash"></i></p-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div> -->

 <!-- Signature dialog -->
    <el-dialog title="Unterschrift" :visible.sync="showSignatureDialog" :close-on-click-modal="true">
      <img :src="dialogSignature.signature" alt="Unterschrift" style="max-width: 100%; max-height: 80vh;"/>
      <span>{{ trainerName }} - ({{ dialogSignature.completedAtLabel }} Uhr)</span>
      <span slot="footer" class="dialog-footer">
        <p-button @click="showSignatureDialog = false">Schließen</p-button>
      </span>
    </el-dialog>

 <!-- Link existing account dialog -->
    <el-dialog title="Bestehenden Account verknüpfen" :visible.sync="showLinkDialog" :close-on-click-modal="true">
      <div v-if="availableUsers.length > 0">
        <p>Benutzer-Account auswählen:</p>
        <el-select v-model="selectedLinkUid" filterable placeholder="Account wählen" style="width: 100%;">
          <el-option v-for="u in availableUsers" :key="u.uid" :label="u.displayName + ' (' + u.displayEmail + ')'" :value="u.uid"></el-option>
        </el-select>
      </div>
      <div v-else>
        <p>Keine verfügbaren (unverknüpften) Accounts gefunden.</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <p-button @click="showLinkDialog = false">Abbrechen</p-button>
        <p-button type="success" @click="linkExistingAccount" :disabled="!selectedLinkUid" class="ml-2">Verknüpfen</p-button>
      </span>
    </el-dialog>

 <!-- New contract dialog -->
    <el-dialog title="Neuer Vertrag" :visible.sync="showContractDialog" :close-on-click-modal="true">
      <div v-if="contractTemplates.length > 0">
        <p>Vertrags-Vorlage wählen:</p>
        <el-table :data="contractTemplates" header-row-class-name="text-primary" empty-text="Keine Vorlagen verfügbar.">
          <el-table-column prop="title" label="Titel" min-width="160"></el-table-column>
          <el-table-column label="" min-width="120">
            <template #default="scope">
              <p-button type="primary" @click="addContractRequest(scope.row)">Vertrag senden</p-button>
            </template>
          </el-table-column>
        </el-table>
        <p class="pt-4">Nach dem Senden des Vertrags wird der Mitarbeiter per E-Mail benachrichtigt und zur Unterschrift aufgefordert.</p>
      </div>
      <div v-else>
        <p>Es sind keine Vorlagen verfügbar.</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <p-button @click="showContractDialog = false">Schließen</p-button>
      </span>
    </el-dialog>

 <!-- Upload document dialog -->
    <el-dialog title="Dokument hochladen" :visible.sync="showDocumentUploadDialog" :close-on-click-modal="false">
      <div>
        <fg-input type="text" label="Titel" v-model="uploadDocTitle"></fg-input>
        <div class="form-group mt-3">
          <input type="file" accept="application/pdf" @change="onDocumentFileSelected" ref="docFileInput" style="display: none;" />
          <button type="button" class="btn btn-default btn-fill" @click="$refs.docFileInput.click()">
            <i class="bi bi-file-earmark-pdf"></i> {{ uploadDocFile ? uploadDocFile.name : 'PDF auswählen...' }}
          </button>
        </div>
        <div class="mt-3">
          <p-switch v-model="uploadDocVisible" type="primary">
            <i class="fa fa-check" slot="on"></i>
            <i class="fa fa-times" slot="off"></i>
          </p-switch> Für Mitarbeiter sichtbar
        </div>
        <div v-if="uploadDocProgress > 0 && uploadDocProgress < 100" class="mt-3">
          <div class="progress">
            <div class="progress-bar bg-success" role="progressbar" :style="{ width: uploadDocProgress + '%' }">{{ uploadDocProgress }}%</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <p-button @click="showDocumentUploadDialog = false" :disabled="uploadDocUploading">Abbrechen</p-button>
        <p-button type="success" @click="uploadDocument" :disabled="!uploadDocTitle || !uploadDocFile || uploadDocUploading" class="ml-2">Hochladen</p-button>
      </span>
    </el-dialog>
</div>
</template>
<script>
  import Vue from 'vue'
  import firebase from 'firebase/compat/app'
  import { db, fc, FirebaseStorage } from '../../../../firebaseDb'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import router from '../../../../main'
  import store from "../../../../store";
  import { Input, Loading, InputNumber, MessageBox, Table, TableColumn, Dialog, Select, Option } from "element-ui";
  import { httpsCallable } from "firebase/functions";
  import { remove } from 'nprogress';
  import moment from "moment-timezone";
  Vue.use(Loading);

  export default {
    components: {
        PSwitch,
        [Input.name]: Input,
        [InputNumber.name]: InputNumber,
        [Select.name]: Select,
        [Option.name]: Option,
        MessageBox,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Dialog.name]: Dialog,
    },

    data () {
      return {
          trainerDocID: 0,
          trainerName: "",
          trainerTelefon: "",
          trainerMail: "",
          trainerNotfallkontaktNummer: "",
          trainerNotfallkontaktName: "",
          trainerWochenstunden: 0,
          trainerUrlaubstage: 0,
          trainerErsteHilefeKursDatum: "",
          trainerIsRetter: false,
          trainerIsHT: false,
          trainerIsKasse: false,
          trainerIsEinweiser: false,
          trainerIsVA: false,
          trainerIsRetterpruefung: false,
          trainerIsRetterBefore: false,
          trainerIsHTBefore: false,
          trainerIsKasseBefore: false,
          trainerIsVABefore: false,
          trainerIsRetterpruefungBefore: false,
          PapershiftAccountId: "",
          dialogSignature: {},
          showSignatureDialog: false,
          paperShiftSyncEnabled: process.env.VUE_APP_ENABLE_PAPERSHIFT_SYNC,
          pickerOptions1: {
            disabledDate(time) {
              return time.getTime() > Date.now();
            },
            firstDayOfWeek: 1,
            shortcuts: [],
          },
          openInstructions: [],
          doneInstructions: [],
          contracts: [],
          contractTemplates: [],
          showContractDialog: false,
          linkedAuthUid: null,
          linkedAuthUsername: '',
          accountLoading: false,
          showLinkDialog: false,
          selectedLinkUid: null,
          availableUsers: [],
          personalDocuments: [],
          documentsLoading: false,
          showDocumentUploadDialog: false,
          uploadDocTitle: '',
          uploadDocFile: null,
          uploadDocVisible: false,
          uploadDocProgress: 0,
          uploadDocUploading: false,
      }
    },
    created () {
        this.trainerDocID = this.$route.params.trainerId

        this.loadData()
    },
    methods: {
        loadData() {
          // get data of trainer
        const trainerRef = db.collection('trainer')
        trainerRef.doc(this.trainerDocID).get().then((doc) => {
            this.trainerName = doc.data().Name
            this.trainerTelefon = doc.data().Telefon
            this.trainerMail = doc.data().Mail
            this.trainerNotfallkontaktNummer = doc.data().NotfallkontaktNummer
            this.trainerNotfallkontaktName = doc.data().NotfallkontaktName
            this.trainerWochenstunden = doc.data().Wochenstunden
            this.trainerUrlaubstage = doc.data().Urlaubstage
            this.trainerErsteHilefeKursDatum = doc.data().ErsteHilfeKursDatum ? doc.data().ErsteHilfeKursDatum.toDate() : ""
            if (this.trainerErsteHilefeKursDatum && this.trainerErsteHilefeKursDatum.getFullYear() == 1970) {
              this.trainerErsteHilefeKursDatum = ""
            }
            if(doc.data().isRetter) {
              this.trainerIsRetter = doc.data().isRetter
              this.trainerIsRetterBefore = doc.data().isRetter
            }
            if(doc.data().isHT) {
              this.trainerIsHT = doc.data().isHT
              this.trainerIsHTBefore = doc.data().isHT
            }
            if(doc.data().isEinweiser) {
              this.trainerIsEinweiser = doc.data().isEinweiser
            }
            if(doc.data().isKasse) {
              this.trainerIsKasse = doc.data().isKasse
              this.trainerIsKasseBefore = doc.data().isKasse
            }
            if(doc.data().isVA) {
              this.trainerIsVA = doc.data().isVA
              this.trainerIsVABefore = doc.data().isVA
            }
            if(doc.data().isRetterpruefung) {
              this.trainerIsRetterpruefung = doc.data().isRetterpruefung
              this.trainerIsRetterpruefungBefore = doc.data().isRetterpruefung
            }
            if(doc.data().PapershiftAccountId && doc.data().PapershiftAccountId !== "") {
              this.PapershiftAccountId = doc.data().PapershiftAccountId
            } else {
              this.PapershiftAccountId = doc.id
            }
            // Load linked auth user info
            if(doc.data().linkedAuthUid) {
              this.linkedAuthUid = doc.data().linkedAuthUid
              var listUsers = httpsCallable(fc, "users-listUsers");
              listUsers([]).then((result) => {
                const user = result.data.users.find(u => u.uid === this.linkedAuthUid);
                if(user) {
                  const suffix = '@' + process.env.VUE_APP_USERNAME_SUFFIX;
                  const displayEmail = user.email.endsWith(suffix) ? user.email.split("@")[0] : user.email;
                  this.linkedAuthUsername = displayEmail + " (" + user.displayName + ")";
                } else {
                  this.linkedAuthUsername = "(Account nicht gefunden)";
                }
              });
            } else {
              this.linkedAuthUid = null;
              this.linkedAuthUsername = '';
            }
        })

        // load assigned instructions for this trainer
        db
          .collection('trainer')
          .doc(this.trainerDocID)
          .collection('unterweisungen')
          .orderBy('assignedAt', 'desc')
          .onSnapshot((snap) => {
            const openList = [];
            const doneList = [];
            snap.forEach((doc) => {
              const d = doc.data();
              const id = doc.id;
              const title = d.title || '(ohne Titel)';
              const assignedAtLabel = this.formatDate(d.assignedAt);
              const completedAtLabel = d.ErledigtDatum ? this.formatDate(d.ErledigtDatum) : (d.completedAt ? this.formatDate(d.completedAt) : '-');
              const signature = d.signature || null;
              const token = d.Token || '';
              const row = { id, title, assignedAtLabel, completedAtLabel, signature, token };
              if ((d.status || 'offen') === 'erledigt') {
                doneList.push(row);
              } else {
                openList.push(row);
              }
            });
            this.openInstructions = openList;
            this.doneInstructions = doneList;
          });

        // load assigned contracts for this trainer
        db
          .collection('contracts')
          .where('trainerId', '==', this.trainerDocID)
          .orderBy('assignedAt', 'desc')
          .onSnapshot((snap) => {
            const list = [];
            snap.forEach((doc) => {
              const d = doc.data();
              const id = doc.id;
              const title = d.title || '(ohne Titel)';
              const assignedAtLabel = this.formatDate(d.assignedAt);
              const completedAtLabel = d.completedAt ? this.formatDate(d.completedAt) : '-';
              const status = d.status || 'offen';
              const documentTemplateUrl = d.documentTemplateUrl || null;
              const documentSignedUrl = d.documentSignedUrl || '';
              const token = d.token || '';
              list.push({ id, title, assignedAtLabel, completedAtLabel, status, documentTemplateUrl, documentSignedUrl, token });
            });
            this.contracts = list;
          });

        // Load personal documents (Personalakte)
        db
          .collection('trainer')
          .doc(this.trainerDocID)
          .collection('documents')
          .orderBy('uploadedAt', 'desc')
          .onSnapshot((snap) => {
            const docs = [];
            snap.forEach((doc) => {
              const d = doc.data();
              docs.push({
                id: doc.id,
                title: d.title || '(ohne Titel)',
                filename: d.filename || '',
                storagePath: d.storagePath || '',
                uploadedByName: d.uploadedByName || '-',
                uploadedAtLabel: this.formatDate(d.uploadedAt),
                visibleToEmployee: d.visibleToEmployee || false,
              });
            });
            this.personalDocuments = docs;
          });
        },
        onCancel () {
            router.push({ name: 'Trainer'})
        },
        formatDate(val) {
          if (!val) return '-';
          try {
            if (val.seconds) {
              return moment(new Date(val.seconds * 1000)).format('DD.MM.YY HH:mm');
            }
            return moment(new Date(val)).format('DD.MM.YY HH:mm');
          } catch(e) { return '-'; }
        },
        updateTrainer () {
            const newRoles = []
            if(this.trainerIsRetter == true && this.trainerIsRetterBefore == false) {
                newRoles.push('Retter')
            }
            if(this.trainerIsHT == true && this.trainerIsHTBefore == false) {
                newRoles.push('Haupttrainer')
            }
            if(this.trainerIsKasse == true && this.trainerIsKasseBefore == false) {
                newRoles.push('Kasse')
            }
            if(this.trainerIsVA == true && this.trainerIsVABefore == false) {
                newRoles.push('Veranstaltungen')
            }
           /* if(newRoles.length > 0) {
                // new role added. Send notification to PL and office
                var sendNotification = httpsCallable(fc, "trainer-NewRoleNotification");
                sendNotification({
                  TrainerName: this.trainerName,
                  NewRoles: newRoles.join(', '),
                  User: store.getters.user.data.displayName,
                  loc: store.getters.userlocation
                })
            }*/
            let ersteHilfe = null
            if(this.trainerErsteHilefeKursDatum) {
              ersteHilfe = this.trainerErsteHilefeKursDatum
            } else {
              ersteHilfe = new Date('1970-01-01')
            }
            const trainerRef = db.collection('trainer')
            trainerRef.doc(this.trainerDocID).update({ Name: this.trainerName, Telefon: this.trainerTelefon, Mail: this.trainerMail, NotfallkontaktName: this.trainerNotfallkontaktName, NotfallkontaktNummer: this.trainerNotfallkontaktNummer, Wochenstunden: this.trainerWochenstunden, Urlaubstage: this.trainerUrlaubstage, ErsteHilfeKursDatum: ersteHilfe, isEinweiser: this.trainerIsEinweiser, isRetter: this.trainerIsRetter, isKasse: this.trainerIsKasse, isHT: this.trainerIsHT, isVA: this.trainerIsVA, isRetterpruefung: this.trainerIsRetterpruefung }).then(() => {
                // Sync retterpruefung to linked auth user claims
                if(this.linkedAuthUid) {
                  var syncRp = httpsCallable(fc, "users-syncRetterpruefung");
                  syncRp({ uid: this.linkedAuthUid, retterpruefungRole: this.trainerIsRetterpruefung }).then(() => {
                    router.push({ name: 'Trainer'})
                  }).catch(() => {
                    router.push({ name: 'Trainer'})
                  });
                } else {
                  router.push({ name: 'Trainer'})
                }
            }).catch((error) => {
                console.log('Fehler beim Speichern des Mitarbeiters: ' + error)
            })
        },
        removeTrainer() {
          MessageBox.confirm(
            "Soll der Mitarbeiter " + this.trainerName + " wirklich aus VertiHub gelöscht werden? Der Mitarbeiter wird für alle zugeordneten Standorte entfernt und in Papershift deaktiviert.",
            "Warnung",
            {
              confirmButtonText: "Löschen",
              cancelButtonText: "Abbrechen",
              type: "warning",
              callback: (action) => {
                if (action == "confirm") {
                  // remove linked auth user if exists
                  if (this.linkedAuthUid) {
                    const removeUser = httpsCallable(fc, "users-removeUser");
                    removeUser({ uid: this.linkedAuthUid }).then(() => {
                      console.log("Verknüpfter User-Account gelöscht");
                    }).catch((error) => {
                      console.error("Fehler beim Löschen des verknüpften User-Accounts: ", error);
                    });
                  }
                  // remove trainer
                  db.collection("trainer")
                    .doc(this.trainerDocID)
                    .delete().then(() => {
                      // deactivate trainer in Papershift
                      const deactivateTrainer = httpsCallable(fc, "papershift-setPSUserInactive");
                      deactivateTrainer({ trainerId: this.trainerDocID, papershiftAccountId: this.PapershiftAccountId }).then(() => {
                        console.log("Mitarbeiter in Papershift deaktiviert");
                        router.push({ name: "Trainer" });
                      }).catch((error) => {
                        console.error("Fehler beim Deaktivieren des Mitarbeiters in Papershift: ", error);
                      });
                    }).catch((error) => {
                      console.error("Fehler beim Löschen des Mitarbeiters: ", error);
                    });
                }
              },
            }
          );
        },
        navigateBack() {
          router.go(-1);
        },
        showSignatureDialogFunction(signature) {
          this.dialogSignature = signature;
          this.showSignatureDialog = true;
        },
        showNewContractDialog() {
          // fetch contract templates
          db.collection('contractTemplates').orderBy('title').get().then((snap) => {
            const templates = [];
            snap.forEach((doc) => {
              const d = doc.data();
              templates.push({ id: doc.id, title: d.title, location: d.location, documentTemplateUrl: d.documentTemplateUrl});
            });
            this.contractTemplates = templates;
            }).then(() => {
              this.showContractDialog = true;
            }).catch((error) => {
              console.error("Fehler beim Laden der Vertragstemplates: ", error);
            });
        },
        generateToken(length = 24) {
          const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
          let result = '';
          if (window && window.crypto && window.crypto.getRandomValues) {
            const array = new Uint32Array(length);
            window.crypto.getRandomValues(array);
            for (let i = 0; i < length; i++) {
              result += chars[array[i] % chars.length];
            }
          } else {
            for (let i = 0; i < length; i++) {
              result += chars[Math.floor(Math.random() * chars.length)];
            }
          }
          return result;
        },
        addContractRequest(template) {
          const token = this.generateToken(32);
          db.collection('contracts').add({
            trainerId: this.trainerDocID,
            title: template.title,
            contractTemplateId: template.id,
            documentTemplateUrl: template.documentTemplateUrl,
            documentSignedUrl: '',
            assignedAt: new Date(),
            status: 'offen',
            token: token,
            location: template.location || 'Unbekannt',
          }).then(() => {
            this.showContractDialog = false;
            this.loadData();
            MessageBox.alert('Der Vertrag wurde erfolgreich angelegt. Der Mitarbeiter wurde per E-Mail benachrichtigt und kann den Vertrag nun unterschreiben.', 'Erfolg', {
              confirmButtonText: 'OK',
            });
          }).catch((error) => {
            console.error("Fehler beim Hinzufügen des Vertrags: ", error);
          });
        },
        removeContract(contract) {
          MessageBox.confirm(
            "Soll der Vertrag " + contract.title + " für " + this.trainerName + " wirklich gelöscht werden?",
            "Warnung",
            {
              confirmButtonText: "Löschen",
              cancelButtonText: "Abbrechen",
              type: "warning",
              callback: (action) => {
                if (action == "confirm") {
                  // remove contract
                  db.collection("contracts")
                    .doc(contract.id)
                    .delete().then(() => {
                      this.loadData();
                    }).catch((error) => {
                      console.error("Fehler beim Löschen des Vertrags: ", error);
                    });
                }
              },
            }
          );
        },
        showContractLink(contract) {
          let url = 'https://ket.weitblick.gmbh/unterweisung/dokument/' + this.trainerDocID + '/' + contract.id + '/' + contract.token + '/';
          // copy url to clipboard
          navigator.clipboard.writeText(url).then(() => {
            MessageBox.alert('Der Link zum Vertrag wurde in die Zwischenablage kopiert und kann nun an den Mitarbeiter weitergegeben werden.<br><br><p><a href="' + url + '" target="_blank">Link zum Vertrag</a></p>', 'Link zum Vertrag', {
              confirmButtonText: 'OK',
              dangerouslyUseHTMLString: true,
            });
          }).catch((error) => { 
            console.error("Fehler beim Kopieren des Links in die Zwischenablage: ", error);
          });
        },
        showInstructionLink(instruction) {
          let url = 'https://ket.weitblick.gmbh/unterweisung/' + instruction.id + '/' + instruction.token + '/' + this.trainerDocID + '/';
          // copy url to clipboard
          navigator.clipboard.writeText(url).then(() => {
            MessageBox.alert('Der Link zur Unterweisung wurde in die Zwischenablage kopiert und kann nun an den Mitarbeiter weitergegeben werden.<br><br><p><a href="' + url + '" target="_blank">Link zur Unterweisung</a></p>', 'Link zur Unterweisung', {
              confirmButtonText: 'OK',
              dangerouslyUseHTMLString: true,
            });
          }).catch((error) => { 
            console.error("Fehler beim Kopieren des Links in die Zwischenablage: ", error);
          });
        },
        sendReminderUnterweisung(instructionId) {
          var sendNotification = httpsCallable(fc, "unterweisung-resendUnterweisungEmail");
          sendNotification({
            trainerId: this.trainerDocID,
            unterweisungId: instructionId
          }).then(() => {
            MessageBox.alert('Die Erinnerung wurde erfolgreich gesendet.', 'Erfolg', {
              confirmButtonText: 'OK',
            });
          }).catch((error) => {
            console.error("Fehler beim Senden der Erinnerung: ", error);
          });
        },
        removeInstruction(instruction) {
          MessageBox.confirm(
            "Soll die Unterweisung '" + instruction.title + "' für " + this.trainerName + " wirklich gelöscht werden?",
            "Warnung",
            {
              confirmButtonText: "Löschen",
              cancelButtonText: "Abbrechen",
              type: "warning",
              callback: (action) => {
                if (action == "confirm") {
                  const deleteSubDoc = db
                    .collection("trainer")
                    .doc(this.trainerDocID)
                    .collection("unterweisungen")
                    .doc(instruction.id)
                    .delete();

                  const updateMainDoc = db
                    .collection("unterweisungen")
                    .doc(instruction.id)
                    .update({
                      trainers: firebase.firestore.FieldValue.arrayRemove(this.trainerDocID),
                    });

                  Promise.all([deleteSubDoc, updateMainDoc])
                    .then(() => {
                      // onSnapshot-Listener aktualisiert die Listen automatisch
                    })
                    .catch((error) => {
                      console.error("Fehler beim Löschen der Unterweisung: ", error);
                    });
                }
              },
            }
          );
        },
        sendReminderVertrag(contractId) {
          var sendNotification = httpsCallable(fc, "contracts-resendContractRequestEmail");
          sendNotification({
            contractId: contractId
          }).then(() => {
            MessageBox.alert('Die Erinnerung wurde erfolgreich gesendet.', 'Erfolg', {
              confirmButtonText: 'OK',
            });
          }).catch((error) => {
            console.error("Fehler beim Senden der Erinnerung: ", error);
          });
        },
        createLinkedAccount() {
          MessageBox.confirm(
            "Soll für " + this.trainerName + " ein neuer Benutzer-Account angelegt werden? Das initiale Passwort wird per E-Mail an " + this.trainerMail + " gesendet.",
            "Account anlegen",
            {
              confirmButtonText: "Anlegen",
              cancelButtonText: "Abbrechen",
              type: "info",
              callback: (action) => {
                if (action == "confirm") {
                  this.accountLoading = true;
                  var createLinked = httpsCallable(fc, "users-createLinkedUser");
                  createLinked({
                    trainerId: this.trainerDocID,
                    location: store.getters.userlocation,
                    role: "1",
                    usernameSuffix: process.env.VUE_APP_USERNAME_SUFFIX,
                  }).then((result) => {
                    this.accountLoading = false;
                    MessageBox.alert(
                      'Der Account <b>' + result.data.username + '</b> wurde erfolgreich angelegt. Das initiale Passwort wurde per E-Mail an den Mitarbeiter gesendet. Bei der ersten Anmeldung muss das Passwort geändert werden.',
                      'Erfolg',
                      {
                        confirmButtonText: 'OK',
                        type: 'success',
                        dangerouslyUseHTMLString: true,
                      }
                    );
                    this.loadData();
                  }).catch((error) => {
                    this.accountLoading = false;
                    MessageBox.alert(
                      error.message || 'Fehler beim Anlegen des Accounts.',
                      'Fehler',
                      { confirmButtonText: 'OK', type: 'error' }
                    );
                  });
                }
              },
            }
          );
        },
        openLinkDialog() {
          // Load all users and filter out those already linked to a trainer
          this.accountLoading = true;
          const suffix = '@' + process.env.VUE_APP_USERNAME_SUFFIX;
          var listUsers = httpsCallable(fc, "users-listUsers");
          listUsers([]).then((result) => {
            this.accountLoading = false;
            this.availableUsers = result.data.users.filter(u => {
              return u.email !== "master@verti-hub.com" && (!u.customClaims || !u.customClaims.linkedTrainerId);
            }).map(u => ({
              ...u,
              displayEmail: u.email.endsWith(suffix) ? u.email.split("@")[0] : u.email,
            }));
            this.selectedLinkUid = null;
            this.showLinkDialog = true;
          });
        },
        linkExistingAccount() {
          if (!this.selectedLinkUid) return;
          this.accountLoading = true;
          var linkUser = httpsCallable(fc, "users-linkExistingUser");
          linkUser({
            trainerId: this.trainerDocID,
            authUid: this.selectedLinkUid,
          }).then(() => {
            this.accountLoading = false;
            this.showLinkDialog = false;
            MessageBox.alert('Der Account wurde erfolgreich verknüpft.', 'Erfolg', {
              confirmButtonText: 'OK',
              type: 'success',
            });
            this.loadData();
          }).catch((error) => {
            this.accountLoading = false;
            MessageBox.alert(
              error.message || 'Fehler beim Verknüpfen.',
              'Fehler',
              { confirmButtonText: 'OK', type: 'error' }
            );
          });
        },
        unlinkAccount() {
          MessageBox.confirm(
            "Soll die Verknüpfung zwischen " + this.trainerName + " und dem Benutzer-Account aufgehoben werden? Der Account wird dadurch nicht gelöscht.",
            "Verknüpfung aufheben",
            {
              confirmButtonText: "Aufheben",
              cancelButtonText: "Abbrechen",
              type: "warning",
              callback: (action) => {
                if (action == "confirm") {
                  this.accountLoading = true;
                  var unlink = httpsCallable(fc, "users-unlinkUser");
                  unlink({ trainerId: this.trainerDocID }).then(() => {
                    this.accountLoading = false;
                    this.loadData();
                  }).catch((error) => {
                    this.accountLoading = false;
                    console.error("Fehler beim Aufheben der Verknüpfung: ", error);
                  });
                }
              },
            }
          );
        },
        showUploadDocumentDialog() {
          this.uploadDocTitle = '';
          this.uploadDocFile = null;
          this.uploadDocVisible = false;
          this.uploadDocProgress = 0;
          this.uploadDocUploading = false;
          this.showDocumentUploadDialog = true;
        },
        onDocumentFileSelected(event) {
          const file = event.target.files[0];
          if (!file) return;
          if (file.type !== 'application/pdf') {
            this.uploadDocFile = null;
            if (this.$refs.docFileInput) this.$refs.docFileInput.value = '';
            MessageBox.alert('Bitte nur PDF-Dateien hochladen.', 'Hinweis', { confirmButtonText: 'OK' });
            return;
          }
          if (file.size > 10 * 1024 * 1024) {
            this.uploadDocFile = null;
            if (this.$refs.docFileInput) this.$refs.docFileInput.value = '';
            MessageBox.alert('Die Datei darf maximal 10 MB groß sein.', 'Hinweis', { confirmButtonText: 'OK' });
            return;
          }
          this.uploadDocFile = file;
        },
        async uploadDocument() {
          if (!this.uploadDocTitle || !this.uploadDocFile) return;
          this.uploadDocUploading = true;
          this.uploadDocProgress = 0;
          const filename = this.uploadDocFile.name.replace(/[\/\\]/g, '_');
          const storagePath = 'personalakte/' + this.trainerDocID + '/' + Date.now() + '_' + filename;
          try {
            const uploadTask = FirebaseStorage.ref(storagePath).put(this.uploadDocFile);
            await new Promise((resolve, reject) => {
              uploadTask.on('state_changed',
                (snapshot) => {
                  this.uploadDocProgress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                },
                (error) => reject(error),
                () => resolve()
              );
            });
            const registerDoc = httpsCallable(fc, "documents-registerDocument");
            await registerDoc({
              trainerId: this.trainerDocID,
              title: this.uploadDocTitle,
              storagePath: storagePath,
              filename: filename,
              visibleToEmployee: this.uploadDocVisible
            });
            this.showDocumentUploadDialog = false;
            this.uploadDocTitle = '';
            this.uploadDocFile = null;
            this.uploadDocVisible = false;
            this.uploadDocProgress = 0;
            if (this.$refs.docFileInput) this.$refs.docFileInput.value = '';
          } catch(e) {
            console.error("Upload error:", e);
            try { await FirebaseStorage.ref(storagePath).delete(); } catch(ce) { /* ignore cleanup error */ }
            MessageBox.alert('Fehler beim Hochladen des Dokuments.', 'Fehler', {
              confirmButtonText: 'OK',
              type: 'error'
            });
          } finally {
            this.uploadDocUploading = false;
          }
        },
        async downloadDocument(doc) {
          this.documentsLoading = true;
          try {
            const getDocData = httpsCallable(fc, "documents-getDocumentData");
            const result = await getDocData({ trainerId: this.trainerDocID, docId: doc.id });
            const base64 = result.data.data;
            const byteChars = atob(base64);
            const byteNumbers = new Array(byteChars.length);
            for (let i = 0; i < byteChars.length; i++) {
              byteNumbers[i] = byteChars.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
          } catch(e) {
            console.error("Download error:", e);
            MessageBox.alert('Fehler beim Herunterladen des Dokuments.', 'Fehler', {
              confirmButtonText: 'OK',
              type: 'error'
            });
          } finally {
            this.documentsLoading = false;
          }
        },
        removeDocument(doc) {
          MessageBox.confirm(
            "Soll das Dokument '" + doc.title + "' wirklich gelöscht werden?",
            "Warnung",
            {
              confirmButtonText: "Löschen",
              cancelButtonText: "Abbrechen",
              type: "warning",
              callback: (action) => {
                if (action === "confirm") {
                  this.documentsLoading = true;
                  const deleteDoc = httpsCallable(fc, "documents-deleteDocument");
                  deleteDoc({ trainerId: this.trainerDocID, docId: doc.id }).then(() => {
                    this.documentsLoading = false;
                  }).catch((error) => {
                    this.documentsLoading = false;
                    console.error("Delete error:", error);
                  });
                }
              },
            }
          );
        },
        toggleDocumentVisibility(doc) {
          const updateDoc = httpsCallable(fc, "documents-updateDocument");
          updateDoc({
            trainerId: this.trainerDocID,
            docId: doc.id,
            visibleToEmployee: doc.visibleToEmployee
          }).catch((error) => {
            console.error("Update error:", error);
            doc.visibleToEmployee = !doc.visibleToEmployee;
          });
        },
  },
}
</script>
<style>

</style>
